import {
  QUERY_KEYS as SHARED_QUERY_KEYS,
  MUTATION_KEYS as SHARED_MUTATION_KEYS,
} from '@avanta/shared/constants/common';

export const QUERY_KEYS = {
  ...SHARED_QUERY_KEYS,
  FETCH_APPOINTMENT_BY_PATIENT: 'FETCH_APPOINTMENT_BY_PATIENT',
  FETCH_CENTER: 'FETCH_CENTER',
  FETCH_DEPARTMENT: 'FETCH_DEPARTMENT',
  FETCH_TREATMENTS: 'FETCH_TREATMENTS',
  FETCH_PSYCHOLOGIST_AVAILABILITY: 'FETCH_PSYCHOLOGIST_AVAILABILITY',
  FETCH_ENTERPRISE_CONTRACTS: 'FETCH_ENTERPRISE_CONTRACTS',
  FETCH_PATIENT_RECORD: 'FETCH_PATIENT_RECORD',
  FETCH_PATIENT_RECORDS: 'FETCH_PATIENT_RECORDS',
  FETCH_REPORT_NOTIFICATIONS: 'FETCH_REPORT_NOTIFICATIONS',
  FETCH_REPORT_NOTIFICATIONS_COUNT: 'FETCH_REPORT_NOTIFICATIONS_COUNT',
};

export const MUTATION_KEYS = {
  ...SHARED_MUTATION_KEYS,
  CREATE_EMPLOYEES: 'CREATE_EMPLOYEES',
  SET_ADMIN_PASSWORD: 'SET_ADMIN_PASSWORD',
  UPLOAD_DOCUMENT: 'UPLOAD_DOCUMENT',
  UPDATE_ADMIN_PREFERENCES: 'UPDATE_ADMIN_PREFERENCES',
  UPDATE_ENTERPRISE_PREFERENCES: 'UPDATE_ENTERPRISE_PREFERENCES',
  VERIFY_REPORT_NOTIFICATION: 'VERIFY_REPORT_NOTIFICATION',
};

export const EMPTY_VALUE = '-';

export const DOCUMENT_CATEGORIES = {
  REFERRAL: 'REFERRAL',
  AUTHORIZATION: 'AUTHORIZATION',
  REPORT: 'REPORT',
  OTHER: 'OTHER',
} as const;
